import axios from "axios";

const baseURL = "https://devdifferencefuncs-staging.azurewebsites.net/api"; // "http://localhost:9000";

export const gennerateToken = async (
  roomName: string,
  participantName: string
) => {
  try {
    const resp = await axios.post(`${baseURL}/get-token`, {
      roomName,
      participantName,
    });

    return resp.data?.token;
  } catch (error) {
    console.log(error);
  }
};

export const startRecording = async (
  roomName: string,
  fileName: string,
  videoTrack: string,
  audioTrackSid: string
) => {
  try {
    const resp = await axios.post(`${baseURL}/start-recording`, {
      roomName,
      fileName,
      videoTrackSid: videoTrack,
      audioTrackSid,
    });

    console.log({ egressId: resp.data });
    return resp.data;
  } catch (error) {
    console.log(error);
  }
};

export const stopRecording = async (egressId: string) => {
  try {
    const resp = await axios.post(`${baseURL}/stop-recording`, {
      egressId,
    });
    return resp.data;
  } catch (error) {
    console.log(error);
  }
};
